import { useState, useCallback } from '../utils/globalImports';
import ApiService, { ApiResponse } from '../services/apiService';


const useApi = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const execute = useCallback(
        async <T>(method: 'get' | 'post' | 'put' | 'delete', endpoint: string, data: any = null,
            responseType: 'json' | 'blob' = 'json'
        ): Promise<ApiResponse<T>> => {
            try {
                // Check if the user is online before making the API call
                if (!navigator.onLine) {
                    const offlineMessage = 'You are currently offline. Please connect to the internet and try again.';
                    setError(offlineMessage);
                    return { data: null, error: offlineMessage };
                }

                setLoading(true);
                setError(null);

                let response: ApiResponse<T>;
                switch (method) {
                    case 'get':
                        response = await ApiService.get<T>(endpoint, data);
                        break;
                    case 'post':
                        response = await ApiService.post<T, any>(endpoint, data, responseType);
                        break;
                    case 'put':
                        response = await ApiService.put<T, any>(endpoint, data);
                        break;
                    case 'delete':
                        response = await ApiService.delete<T>(endpoint);
                        break;
                    default:
                        throw new Error(`Unsupported method: ${method}`);
                }

                if (response.error) {
                    setError(response.error);
                    return { data: null, error: response.error };
                }

                return { data: response.data, error: null };
            } catch (err: any) {
                setError(err.message);
                return { data: null, error: err.message };
            } finally {
                setLoading(false);
            }
        },
        []
    );

    return { execute, loading, error };
};

export default useApi;
